import { useContext, useEffect, useState } from 'react';
import { ToastContext } from '../../../../contexts/ToastContext';
import {
	Dialog,
	DialogClose,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '../../../../components/ui/dialog';
import {
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '../../../../components/ui/alert-dialog';
import apiArComprimido from '../../../../services/apis/apiArComprimido';
import PaginationBar from '../../../../components/common/PaginationBar';
import { useParams } from 'react-router-dom';

export default function ListaArComprimido({
	atualizarLista,
	pesquisar,
	funcaoModalController,
	onClose
}) {
	const [listaArComprimido, setListaArComprimido] = useState([]);
	const { page } = useParams();
	const [pagination, setPagination] = useState();
	const [idEditar, setIdEditar] = useState();
	const [nome, setNome] = useState('');
	const [itemRemovido, setItemRemovido] = useState('');
	const [idRemover, setIdRemover] = useState();
	const { erro, sucesso } = useContext(ToastContext);
	const funcaoModal = funcaoModalController.funcaoModal;
	const [rangeMin, setRangeMin] = useState();
	const [rangeMax, setRangeMax] = useState();
	const [pressaoReferencia, setPressaoReferencia] = useState();

	useEffect(() => {
		apiArComprimido.fetchApi(page).then((res) => {
			setListaArComprimido(res.data.items);
			setPagination(res.data)
		});
	}, [page]);

	function deletar(id) {
		apiArComprimido
			.deleteApi(id)
			.then((res) => {
				atualizarLista();
				sucesso('Ar comprimido deletada com sucesso!');
			})
			.catch((error) => {
				console.error(error.message);
				erro('Erro ao deletar ar comprimido!');
			});
	}

	function enviar(e) {
		e.preventDefault();
		const arComprimido = {
			nome: e.target.nome.value,
			rangeMin: parseFloat(e.target.pressaoMinima.value),
			rangeMax: parseFloat(e.target.pressaoMaxima.value),
			pressaoReferencia: parseFloat(e.target.pressaoReferencia.value),
		};
		if (funcaoModal === 'Adicionar') {
			apiArComprimido
				.postApi(arComprimido)
				.then((res) => {
					atualizarLista();
					setNome('');
					sucesso('Ar comprimido adicionada com sucesso!');
					onClose();
				})
				.catch((error) => {
					erro('Erro ao adicionar ar comprimido!');
					console.error(error.message);
				});
		} else if (funcaoModal === 'Editar') {
			apiArComprimido
				.putApi(idEditar, arComprimido)
				.then((res) => {
					atualizarLista();
					setNome('');
					sucesso('Ar comprimido editada com sucesso!');
					onClose();
				})
				.catch((error) => {
					console.error(error.message);
					erro('Erro ao editar ar comprimido!');
				});
		}
	}

	return (
		<>
			<Dialog>
				{/* LISTA */}
				<div className="w-full flex flex-col items-center mt-[40px] md:px-[200px]">
					<table className="table-auto w-full">
						<thead className="flex border-b">
							<tr>
								<th className="text-[25px] pl-[10px]">
									Nome
								</th>
							</tr>
						</thead>
						<tbody>
							{listaArComprimido.map(
								(arComprimido, i) =>
									arComprimido.nome
										.toUpperCase()
										.startsWith(
											pesquisar.toUpperCase()
										) && (
										<tr
											className="border-b"
											key={i}
										>
											<td className="flex justify-between py-1 hover:bg-gray-200 hover:bg-opacity-5">
												<span className="text-[20px] pl-[10px]">
													{
														arComprimido.nome
													}
												</span>
												<span className="flex">
													<AlertDialogTrigger>
														<div
															onClick={() => {
																setIdEditar(
																	arComprimido.id
																);
																setNome(
																	arComprimido.nome
																);
																setPressaoReferencia(
																	arComprimido.pressaoReferencia
																);
																setRangeMin(
																	arComprimido.rangeMin
																);
																setRangeMax(
																	arComprimido.rangeMax
																);
																funcaoModalController.setFuncaoModal(
																	'Editar'
																);
															}}
														>
															<i
																className="fa-solid fa-pen-to-square text-[18px] hover:text-lightBlue"
																title="Editar"
															></i>
														</div>
													</AlertDialogTrigger>
													<DialogTrigger>
														<div
															className="mx-2.5"
															onClick={() => {
																setItemRemovido(
																	arComprimido.nome
																);
																setIdRemover(
																	arComprimido.id
																);
															}}
														>
															<i
																className="fa-solid fa-trash text-[18px] hover:text-lightBlue"
																title="Deletar"
															></i>
														</div>
													</DialogTrigger>
												</span>
											</td>
										</tr>
									)
							)}
						</tbody>
					</table>
					{
						pagination !== undefined &&
						<PaginationBar pagination={pagination} />
					}
				</div>
				<DialogContent>
					<DialogHeader>
						<DialogTitle>
							Excluir {itemRemovido}?
						</DialogTitle>
					</DialogHeader>
					<DialogDescription>
						Todos os dados associados com {itemRemovido}{' '}
						serão removidos.
					</DialogDescription>
					<DialogFooter>
						<div
							className="bg-red-600/70 py-2 px-4 rounded-md hover:bg-red-600 hover:cursor-pointer border-slate-800 border-2 transition-all duration-200 ease-in-out"
							onClick={() => deletar(idRemover)}
						>
							<DialogClose>Excluir</DialogClose>
						</div>
					</DialogFooter>
				</DialogContent>
			</Dialog>
			<AlertDialogContent>
				<form onSubmit={(e) => enviar(e)}>
					<AlertDialogHeader>
						<AlertDialogTitle>
							{funcaoModal} Ar Comprimido
						</AlertDialogTitle>
					</AlertDialogHeader>
					<div className="w-full max-h-[500px] flex justify-around my-5 px-5 flex-wrap gap-5 overflow-y-auto">

						<div className="flex flex-col justify-end">
							<div className="flex flex-col">
								<label
									htmlFor="nome"
									className="text-[18px] mb-2 pl-1"
								>
									Nome
								</label>
								<input
									id="nome"
									className="border-b text-[20px] p-1.5 bg-[#0b101d] rounded-t-md w-[200px]"
									type="text"
									placeholder="nome"
									value={nome}
									onChange={(e) =>
										setNome(e.target.value)
									}
									required
								/>
							</div>
						</div>
						{/* PRESSAO MINIMA */}
						<div className="flex flex-col justify-end">
							<label
								htmlFor="pressaoMinima"
								className="text-[18px] mb-2 pl-1"
							>
								Pressão mínima
							</label>
							<input
								id="pressaoMinima"
								name="pressaoMinima"
								type="number"
								className="border-b text-[20px] p-1.5 bg-[#0b101d] rounded-t-md w-[180px]"
								value={rangeMin}
								onChange={(e) =>
									setRangeMin(
										e.target.value
									)
								}
								required
							/>
						</div>
						{/* PRESSAO MAXIMA */}
						<div className="flex flex-col justify-end">
							<label
								htmlFor="pressaoMaxima"
								className="text-[18px] mb-2 pl-1"
							>
								Pressão máxima
							</label>
							<input
								id="pressaoMaxima"
								name="pressaoMaxima"
								type="number"
								placeholder="pressão máxima"
								className="border-b text-[20px] p-1.5 bg-[#0b101d] rounded-t-md w-[180px]"
								value={rangeMax}
								onChange={(e) =>
									setRangeMax(
										e.target.value
									)
								}
								required
							/>
						</div>
						{/* PRESSAO REFERENCIA */}
						<div className="flex flex-col justify-end">
							<label
								htmlFor="pressaoReferencia"
								className="text-[18px] mb-2 pl-1"
							>
								Pressão Referência
							</label>
							<input
								id="pressaoReferencia"
								name="pressaoReferencia"
								type="number"
								placeholder="pressão referência"
								className="border-b text-[20px] p-1.5 bg-[#0b101d] rounded-t-md w-[180px]"
								value={pressaoReferencia}
								onChange={(e) =>
									setPressaoReferencia(
										e.target.value
									)
								}
								step="any"
								required
							/>
						</div>
					</div>
					<AlertDialogFooter>
						<div className="flex w-full justify-end gap-x-4 p-4">
							<AlertDialogAction className="w-32">
								Confirmar
							</AlertDialogAction>
							<div onClick={onClose}>
								<AlertDialogCancel className="w-32">
									Cancelar
								</AlertDialogCancel>
							</div>
						</div>
					</AlertDialogFooter>
				</form>
			</AlertDialogContent>
		</>
	);
}
